// In-Built
import {
  Component,
  OnInit,
  Inject,
  ComponentFactoryResolver,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'pp-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['../../forms.component.scss'],
})
export class PpModalComponent implements OnInit {
  @ViewChild('displayComponent', { static: true, read: ViewContainerRef })
  displayComponent!: ViewContainerRef;
  closeDialog: BehaviorSubject<any> = new BehaviorSubject(false);

  public header!: string;
  public dataSource: any;
  public reload!: boolean;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    public dialogRef: MatDialogRef<PpModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.header = this.data.header;
    this.dataSource = this.data.dataSource;
    this.reload = this.data.reload;
    this.createDynamicComponent();
  }

  /**
   * Create Dynamic Component based on Config
   */
  public async createDynamicComponent(): Promise<void> {
    let componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(
        this.data.component,
      );

    if (componentFactory != undefined) {
      let componentRef =
        this.displayComponent?.createComponent<any>(componentFactory) || false;
      const inputKeys = Object.keys(this.data.inputData);
      for (const each of inputKeys) {
        componentRef.instance[each] = this.data.inputData[each];
      }
      // Share data
      componentRef.instance['dataSource'] = this.dataSource;
      this.closeDialog = componentRef.instance['closeDialog'];
      if (this.closeDialog)
        await this.closeDialog
          .pipe(
            tap((val) => {
              setTimeout(() => {
                if (val) {
                  this.dialogRef.close(val);
                }
              }, 0);
            }),
          )
          .toPromise();
    }
  }

  // Close Open Modal
  public closeModal() {
    this.dialogRef.close(this.reload);
  }
}
